import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { PropsStaticPagesState } from '@models/StaticPages';

const initialState: PropsStaticPagesState = {
  data: null,
};

export const staticPageSlice = createSlice({
  name: 'staticPage',
  initialState,
  reducers: {
    setInitStaticPage: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.staticPage,
      };
    });
  },
});

export const { setInitStaticPage } = staticPageSlice.actions;
export const staticReducer = staticPageSlice.reducer;
